import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, formValueSelector } from "redux-form";
import FontIcon from 'react-toolbox/lib/font_icon';

const selector = formValueSelector("poliza-tarjeta-form");

const mapState = (state) => {
	return {
		loading: state.global.loading,
		initialValues: {
			tarjetaTitular: state.global.nombre,
			tarjetaEmisor: "VI"
		},
		dataForm : selector(state, "tarjetaTipo", "tarjetaEmisor", "tarjetaNumero", "tarjetaBanco", "tarjetaTitular", "tarjetaVencimiento" ,"tarjetaCvv"),
		dispositivo: state.global.dispositivo
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},
		alerta: (sMensaje) => {
			dispatch({ "type": "MODAL_ALERT_MESSAGES_SHOW", "titulo": "ERROR", "mensaje" : sMensaje });
		},
		alertaCode: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo" : sCode });
		}
	};
};

const onSubmitFail = (errors,dispatch,submitError, props) => {
	if(errors.tarjetaTipo === "Campo requerido." || errors.tarjetaBanco === "Campo requerido." || errors.tarjetaNumero === "Campo requerido." || errors.tarjetaTitular === "Campo requerido." || errors.tarjetaVencimiento === "Campo requerido." || errors.tarjetaCvv === "Campo requerido.") {
		dispatch({ "type": "EVENT_PAGARRECIBO-VACIOS", "dispositivo": props.dispositivo});
	} else {
		dispatch({ "type": "EVENT_PAGARRECIBO-INCORRECTOS", "dispositivo": props.dispositivo});
	}
};

const numero = value => {
	let numero = (value != undefined)? value.replace(" ","").replace(".","") : "";
	
	if(numero != "" && isNaN(numero)) {
		let _temp = "";
		for(let i = 0; i < numero.length; i++) { 
			if(!isNaN(numero.substr(i,1))) {
				_temp  +=  numero.substr(i,1);
			}
		}
		numero = _temp;
	}

	return numero;
};

const vigencia = value => {
	let numero = (value != undefined)? value.replace(" ","").replace(".","").replace("/","") : "";
	numero = numero.substr(0,2) + "/" + numero.substr(2,6);
	
	if(numero != "") {
		let _temp = "";
		for(let i = 0; i < 7; i++) { 
			if(i == 2) {
				_temp += "/";
			} else {
				if(!isNaN(numero.substr(i,1))) {
					_temp += numero.substr(i,1);
				} else {
					_temp == " ";
				}
			}
		}
		numero = _temp;
	} else {
		numero = "  /  ";
	}

	return  numero;
};

const validate = (campos) => {
	const errors = {};

	if (!campos.tarjetaTipo) {
		errors.tarjetaTipo = "Campo requerido.";
	}
	if (!campos.tarjetaBanco) {
		errors.tarjetaBanco = "Campo requerido.";
	}
	if (!campos.tarjetaNumero) {
		errors.tarjetaNumero = "Campo requerido.";
	} else if(campos.tarjetaEmisor != "AM" && campos.tarjetaNumero.length != 16) {
		errors.tarjetaNumero = "Campo requerido.";
	} else if(campos.tarjetaEmisor == "AM" && campos.tarjetaNumero.length != 15) {
		errors.tarjetaNumero = "Campo requerido.";
	}
	
	if (!campos.tarjetaTitular) {
		errors.tarjetaTitular = "Campo requerido.";
	}
	
	if (!campos.tarjetaVencimiento) {
		errors.tarjetaVencimiento = "Campo requerido.";
	} else if(campos.tarjetaVencimiento.length != 7) {
		errors.tarjetaVencimiento = "Campo requerido.";
	}
	
	if (!campos.tarjetaCvv) {
		errors.tarjetaCvv = "Campo requerido.";
	} else if(campos.tarjetaEmisor != "AM" && campos.tarjetaCvv.length != 3) {
		errors.tarjetaCvv = "Campo requerido.";
	} else if(campos.tarjetaEmisor == "AM" && campos.tarjetaCvv.length != 4) {
		errors.tarjetaCvv = "Campo requerido.";
	}

	return errors;
};

const renderField = ({ input, type, max, meta: { touched, error, warning } }) => {
	return (
		<div>
			<input {...input} type={type} maxLength={max} autoComplete="off" />
			{ touched && (error &&
				<div>
					<div className="msj-error" style={{"top":"53px"}}>
						<p><span>{ error }</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

const renderSelect = ({ input, label, type, meta: { touched, error, warning }, children }) => {
	return (
		<div className="input-wrap">
			<label>{label}</label>
			<span className="clearfix input-active">
				<select {...input} className="col-xs-1">
					{children}
				</select>
			</span>
			{ touched && (error &&
				<div>
					<div className="msj-error" style={{"top":"53px"}}>
						<p><span>{ error }</span></p>
					</div>
				</div>)
			}
		</div>
	);
};

class Tarjeta extends React.Component {

	state = {
		tooltip : false,
		maxtarjeta : 16,
		maxcvv : 3,
		show:true
	}

	onMouseEnterHandler = () => {
		this.setState({
			tooltip: true
		});
	}
	
	onMouseLeaveHandler = () => {
		this.setState({
			tooltip: false
		});
	}

	componentWillMount = () => {
		console.log("componentWillMount");
	}

	componentWillUnmount = () => {
		this.props.reset();
	}

	updateSite = (event) => {
		this.props.change("tarjetaCvv", "");
		this.props.change("tarjetaNumero", "");
		
		if(event.currentTarget.value == "AM") {
			this.setState({maxtarjeta: 15, maxcvv: 4});
		} else {
			this.setState({maxtarjeta: 16, maxcvv: 3});
		}
	}
	toggleInput = (event) => {
		event.preventDefault();
        this.setState({show: !this.state.show});
    }

	render () {
		const { handleSubmit, submitting } = this.props;
		return (
			<form onSubmit={handleSubmit}>
				<div className="col-xs-12 col-md-7 col-md-offset-1 card">
					<div className="row">
						<div className="col-xs-12 col-md-6">
							<div className="row">
								<div className="col-xs-12">
									<Field name="tarjetaTipo" label="Tipo de tarjeta" component={renderSelect}>
										<option value="">Selecciona una opción</option>
										<option value="R">Tarjeta de crédito</option>
										<option value="D">Tarjeta de débito</option>
									</Field>
								</div>
								<ul className="ul-radio">
									<li>
										<Field name="tarjetaEmisor" id="f-option" component="input" type="radio" value="VI" onChange={event => { this.updateSite(event);}} />
										<label htmlFor="f-option">
											<img src={ require("../img/visa-card.png") }/>
										</label>
										<div className="check"></div>
									</li>
									<li>
										<Field name="tarjetaEmisor" id="s-option" component="input" type="radio" value="AM" onChange={event => { this.updateSite(event);}} />
										<label htmlFor="s-option">
											<img src={ require("../img/amex-card.png") }/>
										</label>
										<div className="check"></div>
									</li>
									<li>
										<Field name="tarjetaEmisor" id="d-option" component="input" type="radio" value="MC" onChange={event => { this.updateSite(event);}} />
										<label htmlFor="d-option">
											<img src={ require("../img/mastercard-card.png") }/>
										</label>
										<div className="check"></div>
									</li>
								</ul>
								<div className="col-xs-12">
									<div className="input-wrap">
										<label>Número de tarjeta</label>
										<span className="clearfix input-active" style={{paddingRight:"30px"}}>
											{this.state.show ? 
												<Field name="tarjetaNumero" component={renderField} type="password" max={this.state.maxtarjeta} normalize={numero} />
												:
												<Field name="tarjetaNumero" component={renderField} type="text" max={this.state.maxtarjeta} normalize={numero} />
											}
										</span>
										<button type="button" onClick={this.toggleInput} className={`${this.state.show ? "":"orange-text"}`} style={{padding: "0", marginTop: "-30px",float: "right"}}><FontIcon value='remove_red_eye' style={{border:"0"}}/></button>
									</div>
								</div>
							</div>
						</div>
						<div className="col-xs-12 col-md-6">
							<div className="row">
								<div className="col-xs-12">
									<Field name="tarjetaBanco" label="Banco" component={renderSelect} >
										<option value="" defaultValue>Selecciona una opción</option>
										<option value='0062'>AFIRME</option>
										<option value='0103'>AMERICAN EXPRESS</option>
										<option value='0128'>AUTOFIN </option>
										<option value='0127'>AZTECA</option>
										<option value='0030'>BAJIO</option>
										<option value='0106'>BAMSA</option>
										<option value='0002'>BANAMEX</option>
										<option value='0019'>BANJERCITO</option>
										<option value='0072'>BANORTE</option>
										<option value='0058'>BANREGIO</option>
										<option value='0060'>BANSI</option>
										<option value='0129'>BARCLAYS</option>
										<option value='0012'>BBVA BANCOMER</option>
										<option value='0130'>COMPARTAMOS</option>
										<option value='0126'>CREDIT SUISSE FIRST BOSTON</option>
										<option value='0124'>DEUTSCHE </option>
										<option value='0021'>HSBC</option>
										<option value='0036'>INBURSA</option>
										<option value='0116'>ING</option>
										<option value='0037'>INTERACCIONES</option>
										<option value='0059'>INVEX</option>
										<option value='0032'>IXE</option>
										<option value='0110'>JP MORGAN</option>
										<option value='0042'>MIFEL</option>
										<option value='0014'>SANTANDER</option>
										<option value='0044'>SCOTIABANK INVERLAT </option>
										<option value='0108'>TOKYO</option>
										<option value='0113'>VE POR MAS</option>
										<option value='0134'>WAL-MART</option>
									</Field>
								</div>
								<div className="col-xs-12">
									<div className="input-wrap">
										<label>Nombre del titular</label>
										<span className="clearfix input-active">
											<Field name="tarjetaTitular" component={renderField} type="text" max="80" />
										</span>
									</div>
								</div>
								<div className="col-xs-6 col-md-8 col-xl-8">
									<div className="input-wrap">
										<label>Vencimiento <small>(MM/AAAA)</small></label>
										<span className="clearfix input-active">
											<Field name="tarjetaVencimiento" defaultValue="  /  " component={renderField} type="text" max="7" normalize={vigencia} />
										</span>
									</div>
								</div>
								<div className="col-xs-6 col-md-4 col-xl-4">
									<div className="info-tarjeta-content">
										{ this.state.tooltip &&
											<div className="info-tarjeta card">
												<span>
													<p>Para Visa, MasterCard y Discover (izquierda), los 3 dígitos en la parte posterior de su tarjeta.</p>
													<p>Para American Express (derecha), los 4 Dígitos en el frente de su tarjeta.</p>
													<img src={ require("../img/credit-card-visa.svg") }/>
													<img src={ require("../img/credit-card-amex.svg") }/>
												</span>
											</div>
										}
									</div>
									<div className="input-wrap">
										<label>CVV</label>
										<img onMouseEnter={this.onMouseEnterHandler} onMouseLeave={this.onMouseLeaveHandler} className="icon-info" src={ require("../img/icon-information.png") }/>
										<span className="clearfix input-active">
										<Field name="tarjetaCvv" autocomplete="new-password" label="CVV" component={renderField} type="password" max={this.state.maxcvv} normalize={numero} />
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="row">
						<button type="submit" className="orange-btn" style={{"margin":"25px auto 0px auto","display":"block"}}>Realizar pago</button>
					</div>
				</div>
				<div style={{"display":"none"}}>
					<img src={ require("../img/credit-card-visa.svg") }/>
					<img src={ require("../img/credit-card-amex.svg") }/>
				</div>
			</form>
		);
	}
}

Tarjeta = reduxForm({form: "poliza-tarjeta-form", validate, onSubmitFail})(Tarjeta);
export default connect(mapState, mapDispatch)(Tarjeta);


// WEBPACK FOOTER //
// ./src/home/tarjeta.frm.js